import Button from '@material-ui/core/Button'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import React, { useCallback } from 'react'
import { withTranslation } from 'react-i18next'

import ervLogo from '../images/erv_logo_lg.jpg'
import phoneLogo from '../images/phone-alt.svg'
import { widthXS } from '../theme'
import LanguageSwitch from './LanguageSwitch'

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.primary.White,
    maxWidth: '100%',
    minHeight: 96,
    [theme.breakpoints.down(widthXS)]: {
      minHeight: 56,
    },
  },
  headerBar: {
    display: 'flex',
    backgroundColor: theme.palette.primary.White,
    maxWidth: 1180,
    minHeight: 81,
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  ERVLogo: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    maxWidth: 180,
  },
  Phonelogo: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
    height: 24,
  },
  phoneNumber: {
    fontSize: '1.125rem',
    letterSpacing: 0.27,
    fontFamily: theme.palette.primary.fontW1G,
    color: theme.palette.primary.main,
    [theme.breakpoints.down(widthXS)]: {
      display: 'none',
    },
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
  },
  itemsFlexEnd: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
}))

const Header = ({ t }) => {
  const classes = useStyles()

  const LinkLanguages = [
    { lang: 'RU', link: 'https://eurotravelins.com.ua/ru/' },
    { lang: 'EN', link: 'https://eurotravelins.com.ua/en/' },
    { lang: 'UK', link: 'https://eurotravelins.com.ua/ua/' },
  ]

  const chooseLinkLang = useCallback((lang) => {
    const langData = LinkLanguages.find((item) => item.lang === lang)
    return langData.link
    //eslint-disable-next-line
  }, [])

  function hrefLanguages() {
    switch (t('appl.header.language')) {
      case 'EN':
        return chooseLinkLang('EN')
      case 'RU':
        return chooseLinkLang('RU')
      case 'UK':
        return chooseLinkLang('UK')
      default:
        return chooseLinkLang('UK')
    }
  }

  return (
    <Container className={classes.root}>
      <Grid item xs={12} sm={12} xl={12} container direction="row" className={classes.headerBar}>
        <Grid item xs={4} sm={4} xl={4}>
          <Grid item>
            <Button
              target="_blank"
              href={hrefLanguages()}
              disableFocusRipple
              disableRipple
              style={{ backgroundColor: 'transparent' }}
            >
              <img src={ervLogo} className={classes.ERVLogo} alt="Page Logo" />
            </Button>
          </Grid>
        </Grid>
        <Grid item xs={5} sm={6} xl={6}>
          <Grid item className={classes.itemsFlexEnd}>
            <a href="tel:+380442997887" style={{ textDecoration: 'none' }}>
              <img src={phoneLogo} className={classes.Phonelogo} alt="Phone Logo" />
            </a>
            <Typography className={classes.phoneNumber}>+38 044 299 78 87</Typography>
          </Grid>
        </Grid>
        <Grid item xs={3} sm={2} xl={2}>
          <LanguageSwitch />
        </Grid>
      </Grid>
    </Container>
  )
}
export default withTranslation()(Header)
